<template>
  <div id="app">
    <transition name="fade">
        <router-view  />
    </transition>
  </div>
</template>
<script>
export default {};
</script>

<style>
* {
  box-sizing: border-box;
}

:root {
  --colorRed: #ff4136;
  --colorBlack: #111;
  --colorWhite: #fff;
  --colorGray: #ddd;
  --colorGray2: #eee;

  --colorBorder: var(--colorGray);
  --colorPrimary: var(--colorRed);
  --colorBase: var(--colorBlack);
}

body {
  font-family: "Raleway", sans-serif;
  margin: 0;
  padding: 0;
  color: var(--colorBase);
  background-color: var(--colorWhite);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* button */
.btn {
  color: var(--colorBase);
  cursor: pointer;
  position: relative;
  border: 2px solid var(--colorPrimary);
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
  padding: 0.5rem;
  text-transform: uppercase;
  font-weight: bold;
  background: var(--colorWhite);
  display: inline-block;
  text-decoration: none;
  text-align: center;
}
.btn:hover {
  color: var(--colorWhite) !important;
  background-color: transparent;
  text-shadow: none;
}
.btn:hover:before {
  bottom: 0%;
  top: auto;
  height: 100%;
}
.btn:before {
  display: block;
  position: absolute;
  left: 0px;
  top: 0px;
  height: 0px;
  width: 100%;
  z-index: -1;
  content: "";
  color: var(--colorWhite) !important;
  background: var(--colorPrimary);
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}

.btn--info {
  width: 51px;
  height: 51px;
  vertical-align: top;
  text-transform: none;
  line-height: 32px;
  font-size: 2rem;
  margin-left: 1rem;
}

/* link */
.link {
  color: var(--colorPrimary);
  text-decoration: underline;
}

.link:hover {
  text-decoration: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
